import { BaseModel } from '~/shared/model'

export class QuantumCardModel extends BaseModel {
  id: string = ''
  name: string = ''
  tooltipText?: string = ''
  backgroundColor?: string = ''
  image?: string = ''
  tabIndexCard?: number = -1
}
